import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';
import { ScriptType } from '../../models';
import { IWideState } from '../../IWideState';

const states: IWideState[] = [{
    name: 'fileManagement',
    url: '/fileManagement',
    component: 'wtFileManagementState',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve,
        roles: Resolve.rolesResolve([Roles.administrator, Roles.engineer])
    },
    data: {
        visible: true,
        isAuthenticated: true,
        isConnected: true,
        sortingOrder: 14,
        editRoles: [Roles.administrator, Roles.engineer],
        icon: 'fa-folder-open',
        displayName: 'Files management',
        editButtonVisibility: () => true,
    },
    params: {
        file: '',
        type: ScriptType.PythonV2
    }
}];

export default states;